import { config } from 'data';
import { fileService } from 'services';
import { useQuery } from 'hooks';
import { FileType } from 'types/models';

const useFilesQuery = () => useQuery({
  queryKey: [config.FILES_QUERY_KEY],
  queryFn: () => Promise.all([
    fileService.getFile(FileType.ID),
    fileService.getFile(FileType.SELFIE),
  ]),
});

export default useFilesQuery;
